import {Product, Variant} from "../../../../models/product";
import {Component, h} from "preact";
import styles from './style.module.scss';
import {productService} from "../../../../services/product-service";
import ProductBrand from "../../../product-brand";
import ProductTag from "../../../product-tag";
import {i18nService} from "../../../../services/i18n-service";
import {NY_CountryService} from "../../../../services/country-service";
import App from "../../../app";
import {ProductPrice} from "../../../product-price";

interface Props {
  product: Product;
  variant: Variant;
}

export default class ProductInfoDesktop extends Component<Props> {

  render() {
    const variant = this.props.variant;

    return (
        <div class={styles['product-info']}>

            <div class={styles['product-tag']}>
                <ProductTag variant={variant} desktopColumnCount={undefined}/>
            </div>

            <div class={styles.description}>
                {i18nService.translate(productService.getTranslationKey(this.props.product))}
            </div>

            <ProductPrice variant={variant} styles={styles}/>

            {App.countryCode === 'by' && <div class={styles['detail-view-hint']}> {i18nService.translate('detail_view_hint_navigation_header')}</div>}

            <div class={styles['brand-product-number']}>
                <div class={styles.brand}>
                    <ProductBrand product={this.props.product}/>
                </div>
                <div class={styles['product-number']}>
                    {variant.productId}
                </div>
            </div>
        </div>
    )
  }
}